import { FC } from "react";
import { Button, Tooltip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { getUserPermissionInfoText } from "../../../utils/helpers/getUserPermissionInfoText";
import { useAppAbility } from "@/services/permissions";
import { useAppSelector } from "@/store/hooks";
import { offHourDefaultProviderSelector } from "@/store/automations/selectros/off-hours/offHourDefaultProviderSelector";

export const OffHoursCreateButton: FC = () => {
  const { cannot } = useAppAbility();
  const canNotCreateSchedule = cannot("create", "schedule");
  const defaultProvider = useAppSelector(offHourDefaultProviderSelector);

  const userPermissionTooltipText = canNotCreateSchedule
    ? getUserPermissionInfoText("Create Off Hours")
    : "";

  return (
    <Tooltip arrow title={userPermissionTooltipText}>
      <span>
        <Button
          color="primary"
          component={RouterLink}
          size="small"
          to={"/automations/off-hours/create"}
          variant="outlined"
          startIcon={<AddIcon />}
          disabled={canNotCreateSchedule || !defaultProvider}
        >
          Create Off Hours
        </Button>
      </span>
    </Tooltip>
  );
};
